export default ({ element }) => {
  const { caption, size } = element
  const Hx = `h${size}`
  return (
    <Hx>{caption}</Hx>
  )
}
